import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import HelpIcon from "@mui/icons-material/Help";
// import CardMedia from "@mui/material/CardMedia";
import { styled } from "@mui/material/styles";
import { useTranslate } from "react-admin";

import Notification from "./Notification";
import {
  useIsEnterprisePlan,
  useIsBusinessPlan,
} from "../../helpers/subscriptionPlan";
import { useIsComptr } from "../useProfileParams";

// Styled Components
const StyledButtonSpan = styled("span")(({ theme }) => ({
  float: "right",
}));

// const StyledCardMedia = styled(CardMedia)(() => ({
//   height: "16em",
// }));

const Welcome = (props) => {
  const translate = useTranslate();
  const isEnterprisePlan = useIsEnterprisePlan();
  const isBusinessPlan = useIsBusinessPlan();
  const isComptr = useIsComptr();

  return (
    <Card>
      {/* <StyledCardMedia image={mediaUrl} /> */}
      <CardContent>
        <Typography variant="h5" component="h2">
          {translate("pos.dashboard.welcome.title")}
          <StyledButtonSpan>
            {isEnterprisePlan
              ? `Enterprise Plan`
              : isBusinessPlan
              ? `Business Plan`
              : `Hobbyist Plan`}
          </StyledButtonSpan>
        </Typography>
        {/* <p style={{ color: "red" }}>Dashboard will be disabled temporarily</p> */}
        <Typography component="p">
          {translate("pos.dashboard.welcome.subtitle")}
        </Typography>
        <Typography component="p"></Typography>
        {!isComptr && <Notification />}
      </CardContent>
      <CardActions sx={{ justifyContent: "flex-end" }}>
        <Button href="https://learn.boxify.io/" target="_blank">
          <HelpIcon sx={{ pr: "0.5em" }} />
          {translate("pos.dashboard.welcome.aor_button")}
        </Button>
        {/* <Button href="https://wa.me/60122141203?text=I%20have%20a%20question">
          <CodeIcon sx={{ pr: "0.5em" }} />
          {translate("pos.dashboard.welcome.button2")}
        </Button> */}
      </CardActions>
    </Card>
  );
};

export default Welcome;
